import { withStylePrefix } from '../common/withStylePrefix';
import { ProgressIndicatorComponent, progressIndicatorTemplate } from './ProgressIndicator';
import styles from './ProgressIndicator.styles.scss';
export const progressIndicatorDefinition = {
    baseName: 'progress-indicator',
    template: progressIndicatorTemplate,
    styles: withStylePrefix(styles),
};
export const chameleonProgressIndicator = ProgressIndicatorComponent.compose(progressIndicatorDefinition);
